angular.module('lf.common')

.factory('accountService', function ($http, $rootScope, vindiciaService) {
  
  return {
    deleteCreditCard: function (params) {
      return $http({
        method: 'POST',
        url: lf.data.xhr.shopAction,
        params: {
          // all ATG fields here + product specific
          deleteCreditCardID: params.creditCardId,
          getData: 'savedPaymentInfo',
          updateData: 'true',
          action: 'deleteCreditCard',
          amplifiHandler: '/atg/userprofiling/ProfileFormHandler'
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .success(function (data) {
          $rootScope.$broadcast('account:creditcards:update', data.data.savedPaymentInfo.creditCards);
        });
    },
      
    setCreditCardAsDefault: function (params) {
      return $http({
        method: 'POST',
        url: lf.data.xhr.shopAction,
        params: {
          defaultCreditCardID: params.creditCardId,
          getData: 'savedPaymentInfo',
          updateData: 'true',
          action: 'setDefaultVindiciaCard',
          amplifiHandler: '/atg/userprofiling/ProfileFormHandler'
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .success(function (data) {
          $rootScope.$broadcast('account:creditcards:update', data.data.savedPaymentInfo.creditCards);
        });
    },
    
    resetPassword: function (params) {
      var postParams = {
          getData: 'resetPasswordResponse',
          updateData: 'true',
          action: 'forgotPassword',
          amplifiHandler: '/atg/userprofiling/ProfileFormHandler'
      };
      postParams['atg_lfResetPasswordForm.data.email.value'] = params.email;
      
      return $http({
        method: 'POST',
        url: lf.data.xhr.shopAction,
        params: postParams,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .success(function (data) {
          $rootScope.$broadcast('account:password:reset');
        });
    }
  };
});
